module.exports = __webpack_public_path__ + "static/media/Tile Image 3.802bc1df.png";